export class ListInventoryGlobalDatabasesResponse {
    'globalDatabases';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "globalDatabases",
            "baseName": "globalDatabases",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryGlobalDatabasesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
